<template>
<div class="article-a-spot" :class="[pageConfigLayoutStyle?.ARTICLE_PAGE_WIDE_LAYOUT === pageLayoutStyle ? 'article-a-spot-wide':'article-a-spot-narrow']">
    <div class="content-container">
        <h1 class="pb-0">{{ widgetConfig.H1Text }}</h1>
        <div class="article-info">{{ articleDetailsString }}</div>
        <img @click="openYouTubeModal()" :src="widgetConfig.ImageUrl" alt="" :class="{ 'cursor-pointer': articleDetails.IsVideo, 'mobile-side-padding': widgetConfig.ImageMobilePadding }">
        <h4 class="pb-0">{{ widgetConfig.H4Text }}</h4>
        <p class="pb-0 content-block" v-html="widgetConfig.BodyText"></p>
    </div>

    <div :class="{ 'has-border-bottom': widgetConfig.EnableSeparator }"></div>
</div>
</template>

<script>
import {
    EventBus
} from "@/event-bus.js";
import {
    globalEventConsts
} from "@/constants.js";

export default {
    name: "ArticleStyleH1",
    props: {
        articleDetails: Object,
        widgetConfig: Object,
        pageLayoutStyle:String
    },
    computed: {
        articleDetailsString() {
            const date = new Date(this.articleDetails.PublishDateYear, this.articleDetails.PublishDateMonth - 1, this.articleDetails.PublishDateDay);
            
            const month = date.toLocaleString("en-US", {
                month: "long"
            });

            const dateString = `${month.toUpperCase()} ${date.getDate()}, ${date.getFullYear()}`;
            const tag = this.articleDetails.Tag.toUpperCase();
            return tag ? `${dateString} | ${tag}` : dateString;
        }
    },
    methods: {
        openYouTubeModal() {
            if (this.articleDetails.VideoUrl.trim()) {
                EventBus.$emit(globalEventConsts.SHOW_YOUTUBE_MODAL, this.articleDetails.VideoUrl);
            }
        },
    }
}
</script>

<style lang="scss" scoped>
.article-a-spot {
   .article-a-spot-wide {
    max-width: $page-width-padded;
    margin: auto;
   }

   .article-a-spot-narrow {
    max-width: $narrower-page-width-padded;
    margin: auto;
   }

    .content-container {
        .article-info {
            color: $red;
            font-size: 14px;
            font-weight: $font-weight-bold;
            letter-spacing: 0.75px;
            line-height: 20px;
        }

        img {
            width: 100%;
            display: block;
            padding-top: $spacer-five;
            padding-bottom: $spacer-five;

            &.cursor-pointer {
                &:hover {
                    cursor: pointer;
                }
            }
        }
    }

    .has-border-bottom {
        height: 1px;
        background-color: $grayscale-five;
        margin: $spacer-six 0 0;
    }

    @include tablet {
        padding: 40px $page-padding 0;

        .content-container {
            p {
                padding-top: $spacer-three;
            }

            .article-info {
                padding-top: $spacer-five;
            }
        }
    }

    @include wide-mobile {
        padding-top: $spacer-six;

        .content-container {
            &> :not(img) {
                padding: 0 $page-padding;
            }

            p {
                padding-top: $spacer-five;
            }

            .article-info {
                padding-top: $spacer-three;
            }

            .mobile-side-padding {
                padding: $spacer-five $page-padding;
            }
        }

        .has-border-bottom {
            margin: $spacer-six $page-padding 0;
        }
    }
}
</style>
